/**
 * OpenVRF router (github.com/Robinhood-OSS/OpenVRF `src/OpenVRF.sol` @ 9fb960cf, Apache-2.0): the calls RUNNER's keeper
 * makes and the views it reads. RUNNER's plan deploys this router itself when `params.randomness.mode` is
 * "openvrf-self" (D54); the deployment manifest then carries its address as `openVrfRouter`. The router is compiled
 * outside this repo's toolchain (solc 0.8.28), so its ABI is restated here; contracts/test/OpenVrfRealRouter.t.sol and
 * OpenVrfSelfDeploy.t.sol drive the same signatures against the real bytes.
 */
import { parseAbi } from 'viem';

export const openVrfRouterAbi = parseAbi([
  'function fulfill(uint256 id, bytes signature)',
  'function proveRound(bytes signature, uint64 roundNumber)',
  'function roundRandomness(uint64 round) view returns (bytes32)',
  'function authorizedRelayers(address relayer) view returns (bool)',
  'function requests(uint256 id) view returns (address consumer, uint64 round, uint32 callbackGasLimit, bool fulfilled, bool delivered, uint256 randomWord, uint256 fee)',
  'function GENESIS() view returns (uint256)',
  'function PERIOD() view returns (uint256)',
  'function CHAIN_HASH() view returns (bytes32)',
  'error NotReady()',
  'error AlreadyFulfilled()',
  'error UnauthorizedRelayer()',
  'error InvalidRequest()',
]);

/** drand evmnet (BLS on BN254), the beacon OpenVRF verifies; OpenVRF's CHAIN_HASH without the 0x prefix. */
export const DRAND_EVMNET_CHAIN_HASH = '04f1e9062b8a81f848fded9c12306733282b2727ecced50032187751166ec8c3';
/** OpenVRF's own relayer defaults (relayer/main.mjs `DRAND_URLS`). */
export const DEFAULT_DRAND_URLS: readonly string[] = ['https://api.drand.sh', 'https://api2.drand.sh', 'https://api3.drand.sh'];
